<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="add_view_edit_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="消息触发类型"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.type">
                      <el-radio :label="1">
                        实时触发
                      </el-radio>
                      <el-radio :label="2">
                        定时触发
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="业务单据"
                    prop="businessCode"
                  >
                    <el-select
                      v-model="dialogAddEditForm.businessCode"
                      filterable
                      clearable
                      placeholder="请选择发送消息的业务单据"
                      style="width:100%"
                      @change="businessChangeFun"
                    >
                      <el-option
                        v-for="item in businessOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-select
                      v-model="dialogAddEditForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      @change="provinceChangeFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-select
                      v-model="dialogAddEditForm.cityId"
                      filterable
                      clearable
                      placeholder="请选择城市"
                      style="width:100%"
                      @change="cityChangeFun"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.type === 1"
                  :span="24"
                >
                  <el-form-item
                    label="消息实时触发节点"
                    prop="node"
                  >
                    <el-radio-group v-model="dialogAddEditForm.node">
                      <el-radio :label="1">
                        创建
                      </el-radio>
                      <el-radio :label="2">
                        提交
                      </el-radio>
                      <el-radio :label="3">
                        复核
                      </el-radio>
                      <el-radio :label="4">
                        退回
                      </el-radio>
                      <el-radio :label="5">
                        确认发货
                      </el-radio>
                      <el-radio :label="6">
                        确认总部制作
                      </el-radio>
                      <el-radio :label="7">
                        确认当地制作
                      </el-radio>
                      <el-radio :label="8">
                        确认调拨
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item
                    label="消息通知人员类型"
                    prop="personnelType"
                  >
                    <el-radio-group v-model="dialogAddEditForm.personnelType">
                      <el-radio :label="1">
                        业务单据相关人员
                      </el-radio>
                      <el-radio :label="3">
                        自定义人员
                      </el-radio>
                      <el-radio :label="2">
                        出库库房管理员
                      </el-radio>
                      <el-radio :label="4">
                        库房收货人
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="状态"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.status">
                      <el-radio :label="1">
                        启用
                      </el-radio>
                      <el-radio :label="2">
                        停用
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.personnelType === 1"
                  :span="24"
                >
                  <el-form-item
                    label="业务单据相关人员"
                    prop="businessUsers"
                  >
                    <el-checkbox-group v-model="dialogAddEditForm.businessUsers">
                      <el-checkbox
                        v-for="item in businessOperators"
                        :key="item.fieldDefinition"
                        :label="item.fieldDefinition"
                      >
                        {{ item.fieldName }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditForm.personnelType === 3"
                  :span="24"
                >
                  <el-form-item
                    label="自定义通知人员"
                    prop="userIdArray"
                  >
                    <el-select
                      v-model="dialogAddEditForm.userIdArray"
                      multiple
                      filterable
                      clearable
                      placeholder="请选择消息通知人员"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in userOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.info }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              消息内容模板
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="messageTemplate">
                    <el-input
                      v-model="dialogAddEditForm.messageTemplate"
                      type="textarea"
                      placeholder="请根据系统提供的消息定义字段输入通知消息内容模板"
                      :rows="10"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="messageContentDefinitions.length > 0"
                  :span="24"
                >
                  <el-form-item label="消息内容字段定义">
                    <el-tag
                      v-for="item in messageContentDefinitions"
                      :key="item.fieldDefinition"
                      size="medium"
                      effect="plain"
                      style="margin: 3px;"
                    >
                      {{ item.fieldName }}: {{ item.fieldDefinition }}
                    </el-tag>
                  </el-form-item>
                </el-col>
                <el-col
                  :span="24"
                  class="tips-col"
                >
                  <div class="red">
                    <p>提示：在消息内容模板中引用消息内容字段定义时，使用‘${}’符号引用。</p>
                    <p>示例：业务单据中省区字段定义为province,在消息模板中引用时写为 ${province} </p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          :disabled="operateButtonDisable"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { loadAreaDataApi } from '@/api/area'
import { loadUserAreaSelectDataApi } from '@/api/user'
import { initMessageNotifyPersonnelApi, saveOrUpdateMessageNotifyPersonnelApi, loadBusinessDataApi, loadMessageDefinitionDataApi } from '@/api/messageNotifyPersonnel'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      operateButtonDisable: false,

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        businessCode: [{ required: true, message: '请选择业务单据', trigger: 'change' }],
        node: [{ required: true, message: '请选择消息实时触发节点', trigger: 'change' }],
        personnelType: [{ required: true, message: '请选择消息通知人员类型', trigger: 'change' }],
        businessUsers: [{ required: true, message: '请选择业务单据中的相关人员', trigger: 'change' }],
        userIdArray: [{ required: true, message: '请选择消息通知自定义人员', trigger: 'change' }],
        messageTemplate: [{ max: 2000, message: '消息内容模板最多允许输入2000个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      businessOptions: [],
      userOptions: [],
      messageContentDefinitions: [],
      businessOperators: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.loading = true
        this.operateButtonDisable = false
        this.loadingText = '努力加载数据中，请耐心等待'

        this.provinceOptions = []
        this.cityOptions = []
        this.businessOptions = []
        this.userOptions = []
        this.messageContentDefinitions = []
        this.businessOperators = []
        this.dialogAddEditForm = {
          type: 1,
          businessName: '',
          businessCode: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          node: '',
          personnelType: 3,
          businessOperator: '',
          businessOperatorField: '',
          userIds: '',
          userNames: '',
          messageTemplate: '',
          status: 1,
          businessUsers: [],
          userIdArray: []
        }

        this.initUserSelectData()
        this.initBusinessData()
        this.initProvinceData()
        if (this.eventType === 'edit') {
          this.initEditData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    initEditData () {
      initMessageNotifyPersonnelApi({ id: this.dataId }).then(response => {
        const { data } = response

        for (let key in this.dialogAddEditForm) {
          if (!data[key]) continue
          this.dialogAddEditForm[key] = data[key]
        }

        if (data.businessOperatorField && data.businessOperatorField.length > 0) {
          this.dialogAddEditForm.businessUsers = data.businessOperatorField.split(',')
        }
        if (data.userIds && data.userIds.length > 0) {
          let userIdArray = data.userIds.split(',')
          userIdArray.forEach(item => {
            this.dialogAddEditForm.userIdArray.push(Number(item))
          })
        }

        this.dialogAddEditForm.id = data.id
        this.loadMessageDefinition(data.businessCode)
        if (data.provinceId) {
          this.initCityData(data.provinceId)
        }
        this.loading = false
      })
    },
    // 初始化用户下列数据
    initUserSelectData () {
      loadUserAreaSelectDataApi({ sorts: '1, 2' }).then(response => {
        const { data } = response
        data.forEach(item => {
          this.userOptions.push({ value: item.value, label: item.label, info: item.sortValue + ' ' + item.provinceNames })
        })
      })
    },
    // 初始化业务单据下拉数据
    initBusinessData () {
      loadBusinessDataApi().then(response => {
        this.businessOptions = response.data || []
      })
    },
    // 业务单据选择回调
    businessChangeFun (val) {
      let selectItem = {}
      selectItem = this.businessOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.businessName = selectItem ? selectItem.label : ''
      // 根据业务单据编码获取字段定义
      this.loadMessageDefinition(val)
    },
    // 初始省区下拉数据
    initProvinceData () {
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(res => {
        res.data.forEach(item => {
          this.provinceOptions.push({ label: item.name, value: item.id })
        })

        if (this.eventType === 'add') this.loading = false
      })
    },
    // 选择省区回调
    provinceChangeFun (val) {
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.label : ''
      this.cityOptions = []
      this.dialogAddEditForm.cityName = ''
      this.dialogAddEditForm.cityId = ''
      if (val) {
        this.initCityData(val)
      }
    },
    // 初始城市下拉数据
    initCityData (val) {
      loadAreaDataApi({ parentId: val, isUserArea: 1 }).then(res => {
        res.data.forEach(item => {
          this.cityOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择城市回调
    cityChangeFun (val) {
      let selectItem = {}
      selectItem = this.cityOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.cityName = selectItem ? selectItem.label : ''
    },
    // 获取业务单据的消息定义字段
    loadMessageDefinition (code) {
      this.messageContentDefinitions = []
      this.businessOperators = []
      if (!code) return
      loadMessageDefinitionDataApi({ businessCode: code }).then(response => {
        const { data } = response
        this.messageContentDefinitions = data['1'] || []
        this.businessOperators = data['2'] || []
      })
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '消息通知设置', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          ).then(async () => {
            this.loading = true
            this.loadingText = '正在努力保存数据中'
            this.operateButtonDisable = true

            this.dialogAddEditForm.userIds = ''
            this.dialogAddEditForm.userNames = ''
            this.dialogAddEditForm.businessOperator = ''
            this.dialogAddEditForm.businessOperatorField = ''

            if (this.dialogAddEditForm.personnelType === 1) {
              let businessOperatorNames = ''
              let businessOperatorFields = ''
              this.dialogAddEditForm.businessUsers.forEach(checkedItem => {
                let checkedOperator = this.businessOperators.find(item => {
                  return item.fieldDefinition === checkedItem
                })
                if (checkedOperator) {
                  businessOperatorNames += ',' + checkedOperator.fieldName
                  businessOperatorFields += ',' + checkedOperator.fieldDefinition
                }
              })
              this.dialogAddEditForm.businessOperator = businessOperatorNames ? businessOperatorNames.substring(1) : ''
              this.dialogAddEditForm.businessOperatorField = businessOperatorFields ? businessOperatorFields.substring(1) : ''
            } else if (this.dialogAddEditForm.personnelType === 3) {
              let userIds = ''
              let userNames = ''
              this.dialogAddEditForm.userIdArray.forEach(selectItem => {
                let selectUser = this.userOptions.find(item => {
                  return item.value === selectItem
                })
                if (selectUser) {
                  userIds += ',' + selectUser.value
                  userNames += ',' + selectUser.label
                }
                this.dialogAddEditForm.userIds = userIds ? userIds.substring(1) : ''
                this.dialogAddEditForm.userNames = userNames ? userNames.substring(1) : ''
              })
            }

            saveOrUpdateMessageNotifyPersonnelApi(this.dialogAddEditForm).then(res => {
              if (res.mark === '200') {
                this.$message({ message: res.message, type: 'success' })
                this.reloadData()
                this.modalClose()
              }
            }).catch(() => {
              this.loading = false
              this.operateButtonDisable = false
            })
          }).catch(() => { })
        }
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.tips-col {
  min-height: 20px !important;
  margin-bottom: 3px;
}
</style>
